import { Api } from "../Api";

export async function getEngagementPeriods() {
  const response = await Api.get("/periods", {
    params: { scope: "manager_engagement", granularity: "rolling_28d" },
  });
  return response.data;
}

function addScopeParams(params, { reportingGroupId, locationId } = {}) {
  if (reportingGroupId) params.reporting_group_id = reportingGroupId;
  if (locationId) params.location_id = locationId;
  return params;
}

export async function getEngagementDashboard(periodId, scope = {}) {
  const response = await Api.get("/dashboard/engagement", {
    params: addScopeParams(periodId ? { period_id: periodId } : {}, scope),
  });
  return response.data;
}

export async function getManagerCoachingDashboard({ periodId, jobClass, frameworkFamily, reportingGroupId, locationId } = {}) {
  const params = {};
  if (periodId) params.period_id = periodId;
  if (jobClass) params.job_class = jobClass;
  if (frameworkFamily) params.framework_family = frameworkFamily;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.get("/manager/dashboard/coaching", { params });
  return response.data;
}

export async function refreshManagerCoachingSummary({ periodId, jobClass, frameworkFamily, reportingGroupId, locationId, retryFailed = false } = {}) {
  const params = { job_class: jobClass, framework_family: frameworkFamily };
  if (periodId) params.period_id = periodId;
  if (retryFailed) params.retry_failed = true;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.post("/manager/dashboard/coaching/summary-refresh", null, { params });
  return response.data;
}

export async function getManagerCoachingDimension({ dimensionType, dimensionId, periodId, jobClass, frameworkFamily, reportingGroupId, locationId }) {
  const params = { job_class: jobClass, framework_family: frameworkFamily };
  if (periodId) params.period_id = periodId;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.get(
    `/manager/dashboard/coaching/dimensions/${encodeURIComponent(dimensionType)}/${encodeURIComponent(dimensionId)}`,
    { params }
  );
  return response.data;
}

export async function getEmployeeCoachingPerformance(employeeId, { periodId, jobClass, frameworkFamily, reportingGroupId, locationId } = {}) {
  const params = { job_class: jobClass };
  if (periodId) params.period_id = periodId;
  if (frameworkFamily) params.framework_family = frameworkFamily;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.get(
    `/manager/users/${employeeId}/coaching-performance`,
    { params }
  );
  return response.data;
}

export async function refreshEmployeeCoachingSummary(employeeId, { periodId, jobClass, frameworkFamily, reportingGroupId, locationId, retryFailed = false } = {}) {
  const params = { job_class: jobClass, framework_family: frameworkFamily };
  if (periodId) params.period_id = periodId;
  if (retryFailed) params.retry_failed = true;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.post(
    `/manager/users/${employeeId}/coaching-performance/summary-refresh`,
    null,
    { params }
  );
  return response.data;
}

export async function getEmployeeEngagement(employeeId, { periodId, day, cursor, limit = 50, reportingGroupId, locationId } = {}) {
  const params = { limit };
  if (periodId) params.period_id = periodId;
  if (day) params.day = day;
  if (cursor) params.cursor = cursor;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.get(`/users/${employeeId}/engagement`, { params });
  return response.data;
}

export async function getManagerThreadReview(threadId, { cursor, limit = 100, reportingGroupId, locationId } = {}) {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.get(`/manager/threads/${threadId}/review`, { params });
  return response.data;
}

export async function getManagerCleanedTranscript(conversationId, { cursor, limit = 100, reportingGroupId, locationId, anchorDetailItemId } = {}) {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  if (anchorDetailItemId) params.anchor_detail_item_id = anchorDetailItemId;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.get(
    `/manager/conversations/${conversationId}/cleaned-transcript`,
    { params }
  );
  return response.data;
}

export async function getManagerCoachingGoals(employeeId, { status, reportingGroupId, locationId } = {}) {
  const params = {};
  if (status) params.goal_status = status;
  addScopeParams(params, { reportingGroupId, locationId });
  const response = await Api.get(`/manager/users/${employeeId}/coaching-goals`, { params });
  return response.data;
}

export async function createManagerCoachingGoal(employeeId, body, { reportingGroupId, locationId } = {}) {
  const params = addScopeParams({}, { reportingGroupId, locationId });
  const response = await Api.post(`/manager/users/${employeeId}/coaching-goals`, body, { params });
  return response.data;
}

export async function updateManagerCoachingGoal(goalId, body, { reportingGroupId, locationId } = {}) {
  const params = addScopeParams({}, { reportingGroupId, locationId });
  const response = await Api.patch(`/manager/coaching-goals/${goalId}`, body, { params });
  return response.data;
}

export async function createManagerFeedback(employeeId, message) {
  const response = await Api.post(`/users/${employeeId}/feedback`, { message });
  return response.data;
}
